import { c as _c } from "react/compiler-runtime";
import { IcoWarning40 } from '@onefootprint/icons';
import { Button, PageShell } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
export type PasskeyProcessingResultProps = {
  outcome: 'canceled' | 'failed';
  onContinue: () => void;
};
export const PasskeyProcessingResult = t0 => {
  const $ = _c(13);
  const {
    outcome,
    onContinue
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "identify.passkeyProcessing"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let t2;
  if ($[1] !== outcome || $[2] !== t) {
    t2 = outcome === "canceled" ? t(_temp) : t(_temp2);
    $[1] = outcome;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const title = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IcoWarning40 color="error" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t(_temp3);
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== onContinue || $[8] !== t4) {
    t5 = <Button onClick={onContinue} fullWidth={true} size="large">{t4}</Button>;
    $[7] = onContinue;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5 || $[11] !== title) {
    t6 = <PageShell title={title} headerIcon={t3}>{t5}</PageShell>;
    $[10] = t5;
    $[11] = title;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
function _temp($) {
  return $.cancelled.title;
}
function _temp2($_0) {
  return $_0.error.title;
}
function _temp3($_1) {
  return $_1.doLater;
}